import { render, staticRenderFns } from "./DatePickerDialog.vue?vue&type=template&id=5edf54fa&scoped=true"
import script from "./DatePickerDialog.vue?vue&type=script&lang=ts"
export * from "./DatePickerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf54fa",
  null
  
)

export default component.exports